import React, { useState, useContext, useEffect } from "react";
import { BI_AUT004Context } from "./context";
import GridBody from "./Grid/GridBody";
import NotificationModal from "../../components/Common/NotificationModal";
import BizinBackend from "../../helpers/bizin_helper";
import { useSelector } from "react-redux";
import withRouter from "../../components/Common/withRouter";
import { AuthProtectedContext } from "../../Routes/AuthProtectedContext";
import { fnGetValueByKey } from "../../helpers/functions";
import useGetCsrfToken from "../../Hooks/useGetCsrfToken";

const BI_AUT004 = () => {
  console.log(
    "%c🤖 Transação dinâmica [BI_AUT004]",
    "color: green; font-weight: bold"
  );

  const { transactionData } = useContext(AuthProtectedContext);

  let procedureResultset = [];
  const procedureName = fnGetValueByKey(transactionData, "PROCEDURE_SAVE");
  const procSaveParams = JSON.parse(
    fnGetValueByKey(transactionData, "PROCEDURE_SAVE_PARAM")
  );
  const procDeleteName = fnGetValueByKey(transactionData, "PROCEDURE_DELETE");
  const procDeleteParams = JSON.parse(
    fnGetValueByKey(transactionData, "PROCEDURE_DELETE_PARAM")
  );
  
  try {
    const rawProcedureResultset = fnGetValueByKey(
      transactionData,
      "PROCEDURE_RESULTSET"
    );
    procedureResultset = JSON.parse(rawProcedureResultset);
  } catch (error) {
    console.warn("⚠️ Erro ao fazer parse", error);
  }

  const csrfToken = useGetCsrfToken();

  const { userProfile, accessTokenMsman } = useSelector((state) => ({
    userProfile: state.login.profile,
    accessTokenMsman: state.login.user.access_token,
  }));

  const [inputs, setInputs] = useState({
    Crop: procedureResultset?.[0]?.Crop_Tamanho?.split('x')[0] || 500,
    Crop_Info: procedureResultset?.[0]?.Crop_Tamanho || "500x500" ,
    Imagem: procedureResultset?.[0]?.Imagem || "",
    Nome_Completo:
      procedureResultset?.[0]?.Descricao || userProfile?.Nome_Completo || "",
  });

  const [notif, setNotif] = useState({ isOpen: false, type: "", message: "" });

  const urlParams = new URLSearchParams(window.location.search);
  const isIframeModal = urlParams.get("modal") === "true";

  const handleUpload = async (base64data) => {
    try {
      const _csrf = csrfToken;

      if (!procedureName || !procSaveParams)
        throw new Error(
          "Procedure ou parâmetros não encontrados no retorno do backend"
        );
      const hasCrop = !!procedureResultset?.[0]?.Crop_Tamanho;
      const hasThumbnail = !!procedureResultset?.[0]?.Crop_Thumbnail_Tamanho;

      const [cw, ch] = procedureResultset?.[0]?.Crop_Tamanho.split('x') || [
        undefined,
        undefined,
      ];
      const [tw, th] = procedureResultset?.[0]?.Crop_Thumbnail_Tamanho.split('x') || [
        undefined,
        undefined,
      ];

      const random = Math.floor(Math.random() * 99999);
      const tipoObj = procedureResultset[0].Tipo_Objeto?.toLowerCase() || "obj";
      const date = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      const fileName = `${tipoObj}_${random}_${date}`;

      const uploadTasks = [];

      uploadTasks.push(
        BizinBackend.fileUpload({
          fileName,
          extension: "png",
          ...((hasCrop && cw !== undefined && ch !== undefined) && { crop: { width: Number(cw) , height: Number(ch) } }),
          fileBase64: base64data,
          _csrf,
          access_token_msman: accessTokenMsman,
        })
      );

      uploadTasks.push(
        BizinBackend.fileUpload({
          fileName: `${fileName}_thumbnail`,
          extension: "png",
          ...(hasThumbnail && tw !== undefined && th !== undefined) && { crop: { width: Number(tw), height: Number(th) } },
          fileBase64: base64data,
          _csrf,
          access_token_msman: accessTokenMsman,
        })
      );

      const uploadResults = await Promise.all(uploadTasks);

      const [uploadNormal, uploadThumb] = uploadResults;

      const payload = JSON.stringify({
        imagem: uploadNormal.publicUrl,
        imagem_thumbnail: uploadThumb.publicUrl,
      });

      const finalParams = procSaveParams.map((param) => {
        if (typeof param === "string") {
          let result = param;
          result = result.replace(
            "<#Tipo_Objeto#>",
            procedureResultset[0].Tipo_Objeto
          );
          result = result.replace("<#ID#>", procedureResultset[0].ID);
          result = result.replace("<#Lista_Campos_Valores#>", payload);
          return result;
        }
        return param;
      });

      await BizinBackend.executeProcedure(
        {
          1: finalParams[0],
          2: finalParams[1],
          3: finalParams[2],
          4: finalParams[3],
          5: finalParams[4],
        },
        procedureName,
        _csrf,
        accessTokenMsman
      );

      setInputs((s) => ({
        ...s,
        Imagem: uploadNormal.publicUrl,
      }));
      if(window.parent || window.top) window.parent.postMessage({ type: 'FileModalUpload',  action: "saved", payload: JSON.stringify({
        isOpen: true,
        type: "success",
        message: "Alterações salvas com sucesso.",
        publicUrl: uploadNormal.publicUrl
      }) }, "*");
      else{
        setNotif({
          isOpen: true,
          type: "success",
          message: "Alterações salvas com sucesso.",
        });
      }
    } catch (error) {
      console.error("Erro ao enviar imagem:", error);
      if(window.parent || window.top) window.parent.postMessage({ type: 'FileModalUpload',  action: "saved", payload: JSON.stringify({
        isOpen: true,
        type: "error",
        message: "Erro ao enviar a foto ❌",
      }) }, "*");
      else{
        setNotif({
          isOpen: true,
          type: "error",
          message: "Erro ao enviar a foto ❌",
        });
      }
    }
  };

  const handleRemove = async (isConfirmed = false) => {

    if(!isConfirmed){
      setNotif({
        isOpen: true,
        type: "warning",
        message: "Ao Clicar em 'Confirmar' você exclui definitivamente a foto de perfil.",
        titleCustom: "Você têm certeza que deseja excluir a foto de perfil?",
        confirmButton: true
      });
    }else{
      try {
        const _csrf = csrfToken;
  
        const payload = JSON.stringify({
          imagem: "",
          imagem_thumbnail: "",
        });
  
        const finalParams = procSaveParams.map((param) => {
          if (typeof param === "string") {
            let result = param;
            result = result.replace(
              "<#Tipo_Objeto#>",
              procedureResultset[0].Tipo_Objeto
            );
            result = result.replace("<#ID#>", procedureResultset[0].ID);
            return result;
          }
          return param;
        });
  
        await BizinBackend.executeProcedure(
          {
            1: finalParams[0],
            2: finalParams[1],
            3: finalParams[2],
            4: finalParams[3]
          },
          procDeleteName,
          _csrf,
          accessTokenMsman
        );
  
        setInputs((s) => ({ ...s, Foto_Usuario: "" }));
        if(window.parent || window.top) window.parent.postMessage({ type: 'FileModalUpload',  action: "saved", payload: JSON.stringify({
          isOpen: true,
          isReload: true,
          type: "success",
          titleCustom: "Sucesso!",
          message: "Sua foto de perfil foi excluída!",
          publicUrl: ""
        }) }, "*");
        else{
          setNotif({
            isOpen: true,
            type: "success",
            titleCustom: "Sucesso!",
            message: "Sua foto de perfil foi excluída!",
          });
        }
      } catch (error) {
        console.error(error);
        if(window.parent || window.top) window.parent.postMessage({ type: 'FileModalUpload',  action: "saved", payload: JSON.stringify({
          isOpen: true,
          type: "error",
          message: "Erro ao remover a foto ❌",
        }) }, "*");
        else{
          setNotif({
            isOpen: true,
            type: "error",
            message: "Erro ao remover a foto ❌",
          });
        }
      }
    }

  };

  const handleCloseNotif = () => {
    setNotif((s) => ({ ...s, isOpen: false }));
  };

  useEffect(() => {
    if (isIframeModal) {
      document.body.classList.add("iframe-avatar-mode");
    } else {
      document.body.classList.remove("iframe-avatar-mode");
    }

    return () => {
      document.body.classList.remove("iframe-avatar-mode");
    };
  }, [isIframeModal]);

  return (
    <>
      <NotificationModal
        isOpen={notif.isOpen}
        type={notif.type}
        message={notif.message}
        confirmButton={notif.confirmButton}
        titleCustom={notif.titleCustom}
        onClose={handleCloseNotif}
        onConfirm={() => handleRemove(true)}
      />
      <BI_AUT004Context.Provider
        value={{
          inputs,
          handleUpload,
          handleRemove
        }}
      >
        <GridBody />
      </BI_AUT004Context.Provider>
    </>
  );
};

export default withRouter(BI_AUT004);
